
<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate [formGroup]="StudentEdit">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <!-- <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">All Student Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">Student Data</li>
                            </ol>
                        </div>
                    </div> -->
                    <div class="bc d-flex align-items-center pl-3 pb-3">
                        <img alt="Logo" src="../../assets/img/DivisionMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            Student Setting
                            </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            Student Dynamic Information
                          </p>
                        </div>
                      </div>
                    <mat-accordion>
                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('PersonalDetails')">
                                 <div class="row pt-5 pb-5 mt-2 mb-2">
                                    <div class="col-sm-2 mt-3 mb-3">
                                    <img width="200rem" src="../../assets/img/id-card.png">
                                    </div>
                                    <div class="col-sm-5  ">
                                        <h5 class="lh4 mt-4 main-content-label">Personal Details</h5>
                                    </div>
                                 </div>   
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Parent
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="PersonalDetail">
                                        <tr  *ngFor="let pdetail of getPersonalDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{pdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,pdetail.value,'PersonalDetail')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            >Update</button> -->
                                                            <a (click)="updateDetails(pdetail)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                         </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header  >
                                <mat-panel-title (click)="getData('ContactDetails')">
                                    <div class="row pt-5 pb-5 mt-2 mb-2">
                                        <div class="col-sm-2 mt-3 mb-3">
                                    <img width="200rem"  src="../../assets/img/contact-info.png">
                                       </div>
                                       <div class="col-sm-5  ">
                                           <h5 class="lh4 mt-4 main-content-label">Contact Details</h5>
                                       </div>
                                    </div>   
                                   </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th>Parent</th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="ContactDetail">
                                        <tr *ngFor="let cdetail of getContactDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{cdetail.name}}</mat-label> -->
                                                {{cdetail.controls['FormName'].value}}
                                                <!-- {{cdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,cdetail.value,'ContactDetail')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(cdetail)">Update</button> -->
                                                            <a (click)="updateDetails(cdetail)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title (click)="getData('ReserveDetails')" >
                                    <div class="row pt-5 pb-5 mt-1 mb-2">
                                        <div class="col-sm-2 mt-3 mb-2">
                                            <img width="200rem" src="../../assets/img/agreement.png">
                                       </div>
                                       <div class="col-sm-10  ">
                                           <h5 class="lh4 mt-4 main-content-label">Reservation Details</h5>
                                       </div>
                                    </div>   
                                   </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th>Parent</th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="RegisterDetail">
                                        <tr *ngFor="let regdetail of getRegisterDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{regdetail.name}}</mat-label> -->
                                                {{regdetail.controls['FormName'].value}}
                                                <!-- {{regdetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{regdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,regdetail.value,'RegisterDetail')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(regdetail)">Update</button> -->
                                                            <a (click)="updateDetails(regdetail)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title (click)="getData('QualifyDetails')">
                                    <div class="row pt-5 pb-5 mt-1 mb-2">
                                        <div class="col-sm-2 mt-3 mb-2">
                                            <img width="200rem" src="../../assets/img/qualification.png">
                                       </div>
                                       <div class="col-sm-10 ">
                                           <h5 class="lh4 mt-4 main-content-label">Qualification Details</h5>
                                       </div>
                                    </div>   
                                   </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th>Parent</th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="QualificationDetail">
                                        <tr *ngFor="let quadetail of getQualificationDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{quadetail.name}}</mat-label> -->
                                                {{quadetail.controls['FormName'].value}}
                                                 <!-- {{quadetail.name}}  -->
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{quadetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,quadetail.value,'QualificationDetail')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(quadetail)">Update</button> -->
                                                            <a (click)="updateDetails(quadetail)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title (click)="getData('AdditionalDetail')" >
                                    <div class="row pt-5 pb-5 mt-1 mb-2">
                                        <div class="col-sm-2 mt-3 mb-2">
                                            <img width="200rem" src="../../assets/img/certified.png">
                                       </div>
                                       <div class="col-sm-10">
                                           <h5 class="lh4 mt-4 main-content-label">Additional Details</h5>
                                       </div>
                                    </div>   
                                   </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th>Parent</th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="AdditionalDetail">
                                        <tr *ngFor="let addetail of getAdditionalDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{addetail.name}}</mat-label> -->
                                                 <!-- {{addetail.name}}  -->
                                                 {{addetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{addetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,addetail.value,'AdditionalDetail')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(addetail)">Update</button> -->
                                                            <a (click)="updateDetails(addetail)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <!--  (click)="getData('PhotoSign')" here no data so remove for temparary -->
                                <mat-panel-title >
                                    <div class="row pt-5 pb-5 mt-1 mb-2">
                                        <div class="col-sm-2 mt-3 mb-2">
                                            <img width="200rem" src="../../assets/img/gallery.png">
                                       </div>
                                       <div class="col-sm-10">
                                           <h5 class="lh4 mt-4 main-content-label"> Photo & Signature</h5>
                                       </div>
                                    </div>   
                                   </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th>Parent</th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="PhotoSign">
                                        <tr *ngFor="let photoS of getPhotoSignControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{photoS.name}}</mat-label> -->
                                                 <!-- {{photoS.name}}  -->
                                                 {{photoS.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{photoS.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,photoS.value,'PhotoSign')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(photoS)">Update</button> -->
                                                            <a (click)="updateDetails(photoS)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title (click)="getData('AdmDetails')" >
                                    <div class="row pt-5 pb-5 mt-1 mb-2">
                                        <div class="col-sm-2 mt-3 mb-2">
                                            <img width="200rem" src="../../assets/img/business-card.png">
                                       </div>
                                       <div class="col-sm-10 ">
                                           <h5 class="lh4 mt-4 main-content-label"> Admission Details</h5>
                                       </div>
                                    </div>   
                                   </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th>Parent</th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                        Action
                                    </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="AdmissionDetail">
                                        <tr *ngFor="let admdetail of getAdmissionDetailControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{admdetail.name}}</mat-label> -->
                                                 <!-- {{admdetail.name}}  -->
                                                 {{admdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{admdetail.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,admdetail.value,'AdmDetails')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                          
                                            <td>
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(admdetail)">Update</button> -->
                                                            <a (click)="updateDetails(admdetail)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="row pt-5 pb-5 mt-1 mb-2">
                                        <div class="col-sm-2 mt-3 mb-2">
                                            <img width="200rem" src="../../assets/img/folder (1).png">
                                       </div>
                                       <div class="col-sm-10">
                                           <h5 class="lh4 mt-4 main-content-label">  Document Upload</h5>
                                       </div>
                                    </div>   
                                   </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                              Action
                                             </th>
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="Document">
                                        <tr *ngFor="let doc of getDocumentControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                <!-- <mat-label formControlName="FormName">{{doc.name}}</mat-label> -->
                                                 <!-- {{doc.name}}  -->
                                                 {{doc.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control"
                                                    value="{{doc.display}}">
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Parent</mat-label>
                                                        <mat-select  #select343
                                                         class="colorblack"
                                                         formControlName="ParentID">
                                                        <mat-select-filter *ngIf="select343.focused" 
                                                            [placeholder]="'Filter'" [displayMember]="'FormDisplayName'"
                                                            [array]="parentIdList"
                                                            (filteredReturn)="filteredparentIdList =$event"></mat-select-filter>
                                                            <mat-option 
                                                            [value]=0>
                                                           NA
                                                        </mat-option>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredparentIdList"
                                                            [value]="item.ID">
                                                           {{item.FormDisplayName}}
                                                        </mat-option>

                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select    formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            (click)="updateDetails(doc)">Update</button> -->
                                                            <a (click)="updateDetails(doc)" title="Edit" class="floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                </div>
            </div>
        </div>
    </form>
</body>